import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ResourceService } from "../../../common/resource.service";
import { Usuario } from "./usuario";
import { UsuarioSerializer } from "./usuario.serializer";
import { environment } from "../../../../environments/environment";
import { normalizeBaseUrl } from "../../../../environments/environment.utils";
import { debounceTime, take } from "rxjs/operators";
import { Observable } from "rxjs";
import { QueryOptions } from "../../../common/query.options";

@Injectable()
export class UsuarioService extends ResourceService<Usuario> {
  static RESOURCE: any = "";
  urlAdmin: string = normalizeBaseUrl(environment.apiAdmin);

  constructor(private http: HttpClient) {
    super(http, "usuario", new UsuarioSerializer(Usuario));
  }

  public login(usuario: any) {
    return this.http
      .post(`${this.urlAdmin}/api/auth/user`, usuario)
      .pipe(debounceTime(1000), take(1));
  }

  public loginExternal(usuario: any) {
    return this.http
      .post(`${this.urlAdmin}/api/external/refresh`, usuario)
      .pipe(debounceTime(1000), take(1));
  }

  public alterarSenha(usuario: Usuario) {
    return this.http
      .put(`${this.urlAdmin}/usuario/${usuario.id}`, usuario)
      .pipe(debounceTime(1000), take(1));
  }

  public checarCpf(cpf: string): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.urlAdmin}/administrador/checar/${cpf}`)
      .pipe(take(1));
  }

  buscarTodos(usuario: Usuario, query: QueryOptions): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.urlAdmin}/usuario/todos?${query.toQueryString()}`,
        usuario
      )
      .pipe(take(1));
  }

  public logar() {
    return this.httpClient.get<any>(`${this.urlEndpoint}/logar`).pipe(take(1));
  }

  public logout() {
    return this.httpClient.get<any>(`${this.urlEndpoint}/logout`).pipe(take(1));
  }
}
